import styled from "styled-components";
import TextField from "@mui/material/TextField";
import { styled as MUIstyled } from "@mui/material/styles";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px 24px 32px;
`;

export const Subcontainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-top: 16px;
`;

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 4px;
`;

export const Title = styled.span`
  font-family: 'Poppins', sans-serif;
  font-size: 22px;
  font-weight: 700;
  color: #000000;
  text-align: left;
  width: 100%;
  margin-bottom: 4px;
`;

export const ForgotPassword = styled.div`
  cursor: pointer;
  color: #3487d3;
  font-family: 'Aileron', sans-serif;
  font-weight: 500;
  margin-top: 12px;
  font-size: 12px;
  align-self: flex-start;

  &:hover {
    text-decoration: underline;
  }
`;

export const SocialLoginContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
`;

export const OrContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
  width: 100%;
`;

export const Or = styled.span`
  font-size: 12px;
  font-family: 'Aileron', sans-serif;
  margin: 0 10px;
  color: #aaaaaa;
`;

export const ErrorMessage = styled.span`
  font-family: 'Aileron', sans-serif;
  font-size: 12px;
  color: #e53935;
  align-self: flex-start;
  padding-top: 4px;
`;

export const CustomizedTextField = MUIstyled(TextField)`
  width: 100%;
  margin-top: 16px !important;
  background-color: #ffffff;

  & .MuiInputLabel-root {
    color: #888888;
    font-family: 'Aileron', sans-serif;
    font-size: 14px;
  }

  & .MuiInputLabel-root.Mui-focused {
    color: #000000;
  }

  & .MuiInputBase-root {
    color: #000000;
    font-family: 'Aileron', sans-serif;
    font-size: 14px;
    background-color: #ffffff;
    border-radius: 8px;
  }

  @media (max-width: 700px) {
    & .MuiInputBase-root {
      font-size: 16px;
    }
  }

  & .MuiOutlinedInput-root {
    border-radius: 8px;

    & fieldset {
      border-color: #dddddd;
    }

    &:hover fieldset {
      border-color: #000000;
    }

    &.Mui-focused fieldset {
      border-color: #000000;
      border-width: 1.5px;
    }
  }
`;
